import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@fapp/pipes';
import {
  TuiAutoColorPipe,
  TuiDataList,
  TuiDropdown,
  TuiFallbackSrcPipe,
  TuiFlagPipe,
  TuiHint,
  TuiIcon,
  TuiInitialsPipe,
} from '@taiga-ui/core';
import { TuiAvatar } from '@taiga-ui/kit';
import { PolymorpheusOutlet } from '@taiga-ui/polymorpheus';

import { PermissionsService } from '../core/services/permissions.service';
import { MainNavbarComponent } from './headers/main-navbar/main-navbar.component';
import { NoRoleNavbarComponent } from './headers/no-role-navbar/no-role-navbar.component';
import { UserNavbarComponent } from './headers/user-navbar/user-navbar.component';
import { LangSwitchComponent } from './partials/lang-switch/lang-switch.component';
import { QuickAddMenuComponent } from './partials/quick-add-menu/quick-add-menu.component';
import { SidebarComponent } from './partials/sidebar/sidebar.component';
import { UserMenuComponent } from './partials/user-menu/user-menu.component';
import { ViewMenuComponent } from './partials/view-menu/view-menu.component';
import { LoggedOutLayoutComponent } from './roles/logged-out-layout/logged-out-layout.component';
import { NoRoleLayoutComponent } from './roles/no-role-layout/no-role-layout.component';
import { StaffLayoutComponent } from './roles/staff-layout/staff-layout.component';
import { UserLayoutComponent } from './roles/user-layout/user-layout.component';

@NgModule({
  declarations: [
    LoggedOutLayoutComponent,
    NoRoleLayoutComponent,
    StaffLayoutComponent,
    MainNavbarComponent,
    UserMenuComponent,
    ViewMenuComponent,
    QuickAddMenuComponent,
    LangSwitchComponent,
    UserNavbarComponent,
    NoRoleNavbarComponent,
    UserLayoutComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TuiFlagPipe,
    NgOptimizedImage,
    TuiAvatar,
    ...TuiDataList,
    ...TuiDropdown,
    ...TuiHint,
    TuiIcon,
    PipesModule,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
    PolymorpheusOutlet,
  ],
  providers: [PermissionsService],
  exports: [
    LoggedOutLayoutComponent,
    NoRoleLayoutComponent,
    StaffLayoutComponent,
    SidebarComponent,
  ],
})
export class LayoutsModule {}
